var map = {
	"./png/add.png": 68410,
	"./png/add_icon.png": 61908,
	"./png/add_icon_act.png": 45573,
	"./png/add_rrect_hover.png": 46476,
	"./png/advanced_features.png": 13171,
	"./png/affiliate_head_image.png": 14207,
	"./png/affiliate_index_guide_step1.png": 90192,
	"./png/affiliate_index_guide_step2_en.png": 24517,
	"./png/affiliate_index_guide_step2_es.png": 17088,
	"./png/affiliate_index_guide_step2_fr.png": 56792,
	"./png/affiliate_index_guide_step2_ja.png": 36231,
	"./png/affiliate_index_guide_step2_pt.png": 8152,
	"./png/affiliate_index_guide_step3.png": 13506,
	"./png/affiliate_index_table_large_en.png": 30254,
	"./png/affiliate_index_table_large_es.png": 69787,
	"./png/affiliate_index_table_large_fr.png": 67831,
	"./png/affiliate_index_table_large_ja.png": 82912,
	"./png/affiliate_index_table_large_pt.png": 52083,
	"./png/affiliate_index_table_narrow_en.png": 7798,
	"./png/affiliate_index_table_narrow_es.png": 83795,
	"./png/affiliate_index_table_narrow_fr.png": 57519,
	"./png/affiliate_index_table_narrow_ja.png": 71528,
	"./png/affiliate_index_table_narrow_pt.png": 96203,
	"./png/arrow_ios_right.png": 91689,
	"./png/aspectRatio1b1.png": 46966,
	"./png/aspectRatio2b3.png": 42475,
	"./png/aspectRatio3b2.png": 96599,
	"./png/back_icon.png": 17028,
	"./png/background.png": 2247,
	"./png/bad.png": 69026,
	"./png/bad1.png": 74945,
	"./png/bad2.png": 25962,
	"./png/bad3.png": 76723,
	"./png/bad4.png": 93116,
	"./png/butterfly.png": 19250,
	"./png/button_detail.png": 19619,
	"./png/button_detail_highlight.png": 40094,
	"./png/caret-down.png": 54633,
	"./png/caret-up.png": 81018,
	"./png/celebrate.png": 97516,
	"./png/chrome_icon.png": 97161,
	"./png/clear_icon.png": 78906,
	"./png/clear_icon_act.png": 50291,
	"./png/close_icon.png": 32519,
	"./png/close_icon_hover.png": 51256,
	"./png/coin.png": 1124,
	"./png/crown.png": 69418,
	"./png/crown_w.png": 64120,
	"./png/del_icon.png": 13930,
	"./png/dialog_close.png": 27210,
	"./png/dialog_delete.png": 78213,
	"./png/face_del_icon.png": 79436,
	"./png/face_delete_icon.png": 27706,
	"./png/face_swap_down.png": 16553,
	"./png/face_swap_retry.png": 64919,
	"./png/faceswap_edit_recognized_mapping_arrow.png": 72506,
	"./png/faceswap_example_bad_icon.png": 87532,
	"./png/faceswap_example_bad_item1.png": 4081,
	"./png/faceswap_example_bad_item2.png": 99322,
	"./png/faceswap_example_bad_item3.png": 47075,
	"./png/faceswap_example_bad_item4.png": 87180,
	"./png/faceswap_example_good_icon.png": 93642,
	"./png/faceswap_example_good_item1.png": 42063,
	"./png/faceswap_example_good_item2.png": 6804,
	"./png/faceswap_example_good_item3.png": 27933,
	"./png/faceswap_example_good_item4.png": 31586,
	"./png/faceswap_example_pause_icon.png": 90673,
	"./png/faceswap_example_play_icon.png": 11873,
	"./png/faceswap_file_delete.png": 57780,
	"./png/faceswap_file_full.png": 37994,
	"./png/faceswap_guide_en_item1.png": 48503,
	"./png/faceswap_guide_en_item3.png": 77285,
	"./png/faceswap_guide_es_item1.png": 49630,
	"./png/faceswap_guide_es_item3.png": 83116,
	"./png/faceswap_guide_fr_item1.png": 10614,
	"./png/faceswap_guide_fr_item3.png": 79140,
	"./png/faceswap_guide_item2.png": 93316,
	"./png/faceswap_guide_item4.png": 26578,
	"./png/faceswap_guide_ja_item1.png": 96197,
	"./png/faceswap_guide_ja_item3.png": 67863,
	"./png/faceswap_guide_pt_item1.png": 98770,
	"./png/faceswap_guide_pt_item3.png": 35264,
	"./png/faceswap_guide_zh_item1.png": 58800,
	"./png/faceswap_guide_zh_item3.png": 7522,
	"./png/faceswap_introduce_en_item1.png": 16230,
	"./png/faceswap_introduce_en_item2.png": 57469,
	"./png/faceswap_introduce_en_item3.png": 36340,
	"./png/faceswap_introduce_en_item4.png": 82251,
	"./png/faceswap_introduce_es_item1.png": 47407,
	"./png/faceswap_introduce_es_item2.png": 24948,
	"./png/faceswap_introduce_es_item3.png": 46077,
	"./png/faceswap_introduce_es_item4.png": 53282,
	"./png/faceswap_introduce_fr_item1.png": 4183,
	"./png/faceswap_introduce_fr_item2.png": 15452,
	"./png/faceswap_introduce_fr_item3.png": 32965,
	"./png/faceswap_introduce_fr_item4.png": 48298,
	"./png/faceswap_introduce_ja_item1.png": 93332,
	"./png/faceswap_introduce_ja_item2.png": 28591,
	"./png/faceswap_introduce_ja_item3.png": 89574,
	"./png/faceswap_introduce_ja_item4.png": 82649,
	"./png/faceswap_introduce_pt_item1.png": 63367,
	"./png/faceswap_introduce_pt_item2.png": 44364,
	"./png/faceswap_introduce_pt_item3.png": 96629,
	"./png/faceswap_introduce_pt_item4.png": 72858,
	"./png/faceswap_introduce_zh_item1.png": 77865,
	"./png/faceswap_introduce_zh_item2.png": 29682,
	"./png/faceswap_introduce_zh_item3.png": 51227,
	"./png/faceswap_upload_tutorial.png": 79664,
	"./png/faceswap_upload_tutorial_hover.png": 37743,
	"./png/failed_retry.png": 49463,
	"./png/faq_detail_hover_arrow.png": 17718,
	"./png/faq_detail_normal_arrow.png": 33803,
	"./png/faq_detail_selected_arrow.png": 91977,
	"./png/good.png": 96332,
	"./png/good1.png": 65247,
	"./png/good2.png": 63620,
	"./png/good3.png": 26861,
	"./png/good4.png": 96882,
	"./png/google.png": 92494,
	"./png/hidd_pass_word.png": 88877,
	"./png/history.png": 71627,
	"./png/home_circle.png": 16063,
	"./png/home_introduce_img1.png": 15175,
	"./png/home_introduce_img2.png": 64492,
	"./png/home_top_bg.png": 62342,
	"./png/homefacearrowimg1.png": 91096,
	"./png/homefacearrowimg2.png": 36851,
	"./png/homefacearrowimg3.png": 81642,
	"./png/homefacearrowimg4.png": 64869,
	"./png/homefaceclickimg1.png": 35591,
	"./png/homefaceclickimg2.png": 15532,
	"./png/homefaceclickimg3.png": 84629,
	"./png/homefaceclickimg4.png": 28122,
	"./png/homefaceimg1.png": 32263,
	"./png/homefaceimg2.png": 65228,
	"./png/homefaceimg3.png": 76853,
	"./png/homefaceimg4.png": 24794,
	"./png/icon_cancle.png": 86201,
	"./png/icon_confirm.png": 15565,
	"./png/icon_discount_offer.png": 58075,
	"./png/icon_free_credits.png": 99004,
	"./png/icon_history.png": 88645,
	"./png/icon_play.png": 76103,
	"./png/icon_play_hover.png": 40856,
	"./png/icon_pricing.png": 75039,
	"./png/icon_up.png": 23310,
	"./png/icon_warning.png": 43009,
	"./png/index_section_top.png": 51799,
	"./png/input_type_photo_disable_icon.png": 41750,
	"./png/input_type_photo_icon.png": 33793,
	"./png/input_type_video_disable_icon.png": 99433,
	"./png/input_type_video_icon.png": 63206,
	"./png/insufficient_credits.png": 99325,
	"./png/invisible_icon.png": 52676,
	"./png/inviteShare.png": 18007,
	"./png/invite_bottom_img.png": 10808,
	"./png/invite_top_img.png": 58100,
	"./png/language_option.png": 71949,
	"./png/load_person_icon.png": 9327,
	"./png/loading.png": 3751,
	"./png/logo.png": 63222,
	"./png/logout.png": 94121,
	"./png/looklike_upload_face_oops.png": 51897,
	"./png/looks_like.png": 49825,
	"./png/mobile_history_swiper_close.png": 5328,
	"./png/mult_img_swap_face.png": 81495,
	"./png/mult_video_swap_face.png": 69107,
	"./png/person.png": 42980,
	"./png/person2.png": 66252,
	"./png/photo_too_big.png": 65667,
	"./png/product_down_arrow.png": 62853,
	"./png/product_up_arrow.png": 8562,
	"./png/purchase_commend_left.png": 77190,
	"./png/purchase_commend_right.png": 69339,
	"./png/purchase_comment_icon1.png": 51549,
	"./png/purchase_comment_icon2.png": 26662,
	"./png/purchase_comment_icon3.png": 65679,
	"./png/purchase_comment_icon4.png": 22832,
	"./png/recognized_mapping_arrow.png": 45654,
	"./png/recognized_mapping_arrow_highlight.png": 12587,
	"./png/retry_big.png": 10774,
	"./png/retry_small.png": 6577,
	"./png/review_rata_bar.png": 74652,
	"./png/review_user1_avatar.png": 9054,
	"./png/review_user2_avatar.png": 78387,
	"./png/review_user3_avatar.png": 62352,
	"./png/review_user4_avatar.png": 13293,
	"./png/review_user5_avatar.png": 87818,
	"./png/review_user6_avatar.png": 44991,
	"./png/right.png": 82301,
	"./png/show_pass_word.png": 52527,
	"./png/sign_img_swap_face.png": 42190,
	"./png/sign_video_swap_face.png": 66254,
	"./png/step_1.png": 941,
	"./png/step_2.png": 85526,
	"./png/step_3.png": 22975,
	"./png/sw_add.png": 67469,
	"./png/sw_lef_select.png": 15538,
	"./png/sw_left_def.png": 80661,
	"./png/sw_left_select.png": 64514,
	"./png/sw_right_def.png": 7170,
	"./png/sw_right_select.png": 11295,
	"./png/swiper_left.png": 9915,
	"./png/swiper_right.png": 5700,
	"./png/textToImgDefBackimg.png": 1373,
	"./png/top_narrow_tool_entrance.png": 73776,
	"./png/tutorial_item1_en.png": 86254,
	"./png/tutorial_item1_es.png": 4219,
	"./png/tutorial_item1_fr.png": 79415,
	"./png/tutorial_item1_ja.png": 39808,
	"./png/tutorial_item1_pt.png": 10643,
	"./png/tutorial_item2.png": 1025,
	"./png/tutorial_item3_en.png": 22400,
	"./png/tutorial_item3_es.png": 29829,
	"./png/tutorial_item3_fr.png": 17741,
	"./png/tutorial_item3_ja.png": 97954,
	"./png/tutorial_item3_pt.png": 53065,
	"./png/tutorial_item4.png": 12535,
	"./png/txtToImg_howtouse1.png": 63581,
	"./png/txtToImg_howtouse2.png": 82374,
	"./png/txtToImg_howtouse3.png": 21391,
	"./png/txtToImg_introduce1.png": 44300,
	"./png/txtToImg_introduce2.png": 11335,
	"./png/txtToImg_introduce3.png": 35550,
	"./png/txtToImg_publish.png": 11035,
	"./png/txtToImg_report.png": 3362,
	"./png/txtToIndex_faqItem_close.png": 90063,
	"./png/txtToIndex_faqItem_expand.png": 41243,
	"./png/txtToIndex_review_avatar1.png": 57610,
	"./png/txtToIndex_review_avatar2.png": 6593,
	"./png/txtToIndex_review_avatar3.png": 33880,
	"./png/txtToIndex_review_avatar4.png": 13495,
	"./png/txtToIndex_review_avatar5.png": 39854,
	"./png/txtToIndex_review_avatar6.png": 42277,
	"./png/txt_to_img_history_add.png": 49122,
	"./png/txt_to_img_history_add_act.png": 70795,
	"./png/txt_to_img_history_close.png": 51639,
	"./png/txt_to_img_more.png": 20659,
	"./png/txt_to_img_more_act.png": 74954,
	"./png/unselect.png": 76306,
	"./png/upload_file_delete.png": 7401,
	"./png/user_login_avatar.png": 15994,
	"./png/user_signup_icon.png": 67067,
	"./png/video_icon.png": 83700,
	"./png/video_too_big.png": 95130,
	"./png/warning_report.png": 11622,
	"./png/warning_report_hover.png": 19213,
	"./webp/add.webp": 3598,
	"./webp/add_icon.webp": 55450,
	"./webp/add_icon_act.webp": 47413,
	"./webp/add_rrect_hover.webp": 68228,
	"./webp/advanced_features.webp": 62401,
	"./webp/affiliate_head_image.webp": 74603,
	"./webp/affiliate_index_guide_step1.webp": 37376,
	"./webp/affiliate_index_guide_step2_en.webp": 63013,
	"./webp/affiliate_index_guide_step2_es.webp": 93374,
	"./webp/affiliate_index_guide_step2_fr.webp": 29670,
	"./webp/affiliate_index_guide_step2_ja.webp": 20843,
	"./webp/affiliate_index_guide_step2_pt.webp": 56330,
	"./webp/affiliate_index_guide_step3.webp": 33794,
	"./webp/affiliate_index_table_large_en.webp": 36768,
	"./webp/affiliate_index_table_large_es.webp": 51863,
	"./webp/affiliate_index_table_large_fr.webp": 1507,
	"./webp/affiliate_index_table_large_ja.webp": 19438,
	"./webp/affiliate_index_table_large_pt.webp": 44179,
	"./webp/affiliate_index_table_narrow_en.webp": 97510,
	"./webp/affiliate_index_table_narrow_es.webp": 10333,
	"./webp/affiliate_index_table_narrow_fr.webp": 55765,
	"./webp/affiliate_index_table_narrow_ja.webp": 37492,
	"./webp/affiliate_index_table_narrow_pt.webp": 15125,
	"./webp/arrow_ios_right.webp": 58147,
	"./webp/aspectRatio1b1.webp": 3380,
	"./webp/aspectRatio2b3.webp": 23355,
	"./webp/aspectRatio3b2.webp": 42263,
	"./webp/back_icon.webp": 5016,
	"./webp/background.webp": 93971,
	"./webp/bad.webp": 70494,
	"./webp/bad1.webp": 43229,
	"./webp/bad2.webp": 48976,
	"./webp/bad3.webp": 71187,
	"./webp/bad4.webp": 46798,
	"./webp/butterfly.webp": 91362,
	"./webp/button_detail.webp": 61461,
	"./webp/button_detail_highlight.webp": 9050,
	"./webp/celebrate.webp": 95404,
	"./webp/clear_icon.webp": 50264,
	"./webp/clear_icon_act.webp": 19771,
	"./webp/close_icon.webp": 42995,
	"./webp/close_icon_hover.webp": 97234,
	"./webp/coin.webp": 20638,
	"./webp/crown.webp": 32054,
	"./webp/crown_w.webp": 336,
	"./webp/del_icon.webp": 64912,
	"./webp/dialog_close.webp": 8744,
	"./webp/dialog_delete.webp": 92535,
	"./webp/face_delete_icon.webp": 87496,
	"./webp/face_swap_down.webp": 17357,
	"./webp/face_swap_retry.webp": 4585,
	"./webp/faceswap_edit_recognized_mapping_arrow.webp": 23308,
	"./webp/faceswap_example_bad_icon.webp": 81148,
	"./webp/faceswap_example_bad_item1.webp": 41933,
	"./webp/faceswap_example_bad_item2.webp": 63616,
	"./webp/faceswap_example_bad_item3.webp": 94019,
	"./webp/faceswap_example_bad_item4.webp": 958,
	"./webp/faceswap_example_good_icon.webp": 23260,
	"./webp/faceswap_example_good_item1.webp": 5133,
	"./webp/faceswap_example_good_item2.webp": 62048,
	"./webp/faceswap_example_good_item3.webp": 49539,
	"./webp/faceswap_example_good_item4.webp": 13950,
	"./webp/faceswap_example_pause_icon.webp": 36767,
	"./webp/faceswap_example_play_icon.webp": 37645,
	"./webp/faceswap_file_delete.webp": 79954,
	"./webp/faceswap_file_full.webp": 59080,
	"./webp/faceswap_guide_en_item1.webp": 42897,
	"./webp/faceswap_guide_en_item3.webp": 3543,
	"./webp/faceswap_guide_es_item1.webp": 37062,
	"./webp/faceswap_guide_es_item3.webp": 72292,
	"./webp/faceswap_guide_fr_item1.webp": 49234,
	"./webp/faceswap_guide_fr_item3.webp": 31120,
	"./webp/faceswap_guide_item2.webp": 56658,
	"./webp/faceswap_guide_item4.webp": 4428,
	"./webp/faceswap_guide_ja_item1.webp": 10851,
	"./webp/faceswap_guide_ja_item3.webp": 35469,
	"./webp/faceswap_guide_pt_item1.webp": 7138,
	"./webp/faceswap_guide_pt_item3.webp": 27072,
	"./webp/faceswap_guide_zh_item1.webp": 41796,
	"./webp/faceswap_guide_zh_item3.webp": 90214,
	"./webp/faceswap_introduce_en_item1.webp": 57694,
	"./webp/faceswap_introduce_en_item2.webp": 46335,
	"./webp/faceswap_introduce_en_item3.webp": 56092,
	"./webp/faceswap_introduce_en_item4.webp": 98669,
	"./webp/faceswap_introduce_es_item1.webp": 59097,
	"./webp/faceswap_introduce_es_item2.webp": 58588,
	"./webp/faceswap_introduce_es_item3.webp": 86527,
	"./webp/faceswap_introduce_es_item4.webp": 90626,
	"./webp/faceswap_introduce_fr_item1.webp": 59581,
	"./webp/faceswap_introduce_fr_item2.webp": 16752,
	"./webp/faceswap_introduce_fr_item3.webp": 42515,
	"./webp/faceswap_introduce_fr_item4.webp": 28974,
	"./webp/faceswap_introduce_ja_item1.webp": 16648,
	"./webp/faceswap_introduce_ja_item2.webp": 39701,
	"./webp/faceswap_introduce_ja_item3.webp": 88522,
	"./webp/faceswap_introduce_ja_item4.webp": 37799,
	"./webp/faceswap_introduce_pt_item1.webp": 26337,
	"./webp/faceswap_introduce_pt_item2.webp": 78852,
	"./webp/faceswap_introduce_pt_item3.webp": 41447,
	"./webp/faceswap_introduce_pt_item4.webp": 59914,
	"./webp/faceswap_introduce_zh_item1.webp": 56407,
	"./webp/faceswap_introduce_zh_item2.webp": 47158,
	"./webp/faceswap_introduce_zh_item3.webp": 11889,
	"./webp/faceswap_upload_tutorial.webp": 83438,
	"./webp/faceswap_upload_tutorial_hover.webp": 22951,
	"./webp/failed_retry.webp": 99927,
	"./webp/faq_detail_hover_arrow.webp": 62868,
	"./webp/faq_detail_normal_arrow.webp": 47641,
	"./webp/faq_detail_selected_arrow.webp": 29871,
	"./webp/good.webp": 63506,
	"./webp/good1.webp": 98409,
	"./webp/good2.webp": 4044,
	"./webp/good3.webp": 61135,
	"./webp/good4.webp": 22354,
	"./webp/google.webp": 30456,
	"./webp/hidd_pass_word.webp": 87021,
	"./webp/history.webp": 51429,
	"./webp/home_circle.webp": 58177,
	"./webp/home_introduce_img1.webp": 45665,
	"./webp/home_introduce_img2.webp": 25028,
	"./webp/homefacearrowimg1.webp": 97740,
	"./webp/homefacearrowimg2.webp": 92009,
	"./webp/homefacearrowimg3.webp": 95982,
	"./webp/homefacearrowimg4.webp": 57619,
	"./webp/homefaceclickimg1.webp": 53481,
	"./webp/homefaceclickimg2.webp": 42764,
	"./webp/homefaceclickimg3.webp": 99855,
	"./webp/homefaceclickimg4.webp": 77426,
	"./webp/homefaceimg1.webp": 74087,
	"./webp/homefaceimg2.webp": 58470,
	"./webp/homefaceimg3.webp": 44577,
	"./webp/homefaceimg4.webp": 2952,
	"./webp/icon_cancle.webp": 98231,
	"./webp/icon_confirm.webp": 13441,
	"./webp/icon_discount_offer.webp": 18557,
	"./webp/icon_free_credits.webp": 16076,
	"./webp/icon_history.webp": 86697,
	"./webp/icon_play.webp": 31661,
	"./webp/icon_play_hover.webp": 77020,
	"./webp/icon_pricing.webp": 35623,
	"./webp/icon_up.webp": 63826,
	"./webp/icon_warning.webp": 61761,
	"./webp/index_section_top.webp": 65089,
	"./webp/input_type_photo_disable_icon.webp": 62790,
	"./webp/input_type_photo_icon.webp": 56259,
	"./webp/input_type_video_disable_icon.webp": 30147,
	"./webp/input_type_video_icon.webp": 526,
	"./webp/insufficient_credits.webp": 22501,
	"./webp/inviteShare.webp": 89629,
	"./webp/invite_bottom_img.webp": 39308,
	"./webp/invite_top_img.webp": 79286,
	"./webp/language_option.webp": 93375,
	"./webp/loading.webp": 65837,
	"./webp/logo.webp": 83736,
	"./webp/logout.webp": 29133,
	"./webp/looklike_upload_face_oops.webp": 74711,
	"./webp/looks_like.webp": 13545,
	"./webp/mult_img_swap_face.webp": 33727,
	"./webp/mult_video_swap_face.webp": 66559,
	"./webp/person.webp": 84374,
	"./webp/person2.webp": 91992,
	"./webp/photo_too_big.webp": 55797,
	"./webp/product_down_arrow.webp": 80293,
	"./webp/product_up_arrow.webp": 87536,
	"./webp/purchase_commend_left.webp": 75814,
	"./webp/purchase_commend_right.webp": 54879,
	"./webp/purchase_comment_icon1.webp": 69181,
	"./webp/purchase_comment_icon2.webp": 26352,
	"./webp/purchase_comment_icon3.webp": 52115,
	"./webp/purchase_comment_icon4.webp": 38574,
	"./webp/recognized_mapping_arrow.webp": 10352,
	"./webp/recognized_mapping_arrow_highlight.webp": 37471,
	"./webp/retry_big.webp": 8746,
	"./webp/retry_small.webp": 99919,
	"./webp/review_rata_bar.webp": 12188,
	"./webp/review_user1_avatar.webp": 74414,
	"./webp/review_user2_avatar.webp": 60417,
	"./webp/review_user3_avatar.webp": 22188,
	"./webp/review_user4_avatar.webp": 919,
	"./webp/review_user5_avatar.webp": 34874,
	"./webp/review_user6_avatar.webp": 62861,
	"./webp/right.webp": 23467,
	"./webp/show_pass_word.webp": 52403,
	"./webp/sign_img_swap_face.webp": 61104,
	"./webp/sign_video_swap_face.webp": 7460,
	"./webp/step_1.webp": 49681,
	"./webp/step_2.webp": 52340,
	"./webp/step_3.webp": 94199,
	"./webp/sw_add.webp": 47541,
	"./webp/sw_left_def.webp": 64079,
	"./webp/sw_left_select.webp": 64840,
	"./webp/sw_right_def.webp": 16628,
	"./webp/sw_right_select.webp": 84553,
	"./webp/swiper_left.webp": 46453,
	"./webp/swiper_right.webp": 47598,
	"./webp/textToImgDefBackimg.webp": 67743,
	"./webp/top_narrow_tool_entrance.webp": 87134,
	"./webp/tutorial_item1_en.webp": 47022,
	"./webp/tutorial_item1_es.webp": 94325,
	"./webp/tutorial_item1_fr.webp": 52813,
	"./webp/tutorial_item1_ja.webp": 19516,
	"./webp/tutorial_item1_pt.webp": 65293,
	"./webp/tutorial_item2.webp": 3461,
	"./webp/tutorial_item3_en.webp": 91036,
	"./webp/tutorial_item3_es.webp": 77915,
	"./webp/tutorial_item3_fr.webp": 45287,
	"./webp/tutorial_item3_ja.webp": 21962,
	"./webp/tutorial_item3_pt.webp": 96263,
	"./webp/tutorial_item4.webp": 19127,
	"./webp/txtToImg_howtouse1.webp": 4809,
	"./webp/txtToImg_howtouse2.webp": 10540,
	"./webp/txtToImg_howtouse3.webp": 85423,
	"./webp/txtToImg_introduce1.webp": 35064,
	"./webp/txtToImg_introduce2.webp": 96165,
	"./webp/txtToImg_introduce3.webp": 24666,
	"./webp/txtToImg_publish.webp": 95215,
	"./webp/txtToImg_report.webp": 90706,
	"./webp/txtToIndex_faqItem_close.webp": 11815,
	"./webp/txtToIndex_faqItem_expand.webp": 84185,
	"./webp/txtToIndex_review_avatar1.webp": 54290,
	"./webp/txtToIndex_review_avatar2.webp": 88563,
	"./webp/txtToIndex_review_avatar3.webp": 62800,
	"./webp/txtToIndex_review_avatar4.webp": 14121,
	"./webp/txtToIndex_review_avatar5.webp": 75022,
	"./webp/txtToIndex_review_avatar6.webp": 34319,
	"./webp/txt_to_img_history_add.webp": 88768,
	"./webp/txt_to_img_history_add_act.webp": 94867,
	"./webp/txt_to_img_history_close.webp": 55767,
	"./webp/txt_to_img_more.webp": 29865,
	"./webp/txt_to_img_more_act.webp": 12278,
	"./webp/unselect.webp": 50880,
	"./webp/upload_file_delete.webp": 2313,
	"./webp/user_login_avatar.webp": 33982,
	"./webp/user_signup_icon.webp": 15467,
	"./webp/video_icon.webp": 34098,
	"./webp/video_too_big.webp": 5058,
	"./webp/warning_report.webp": 31648,
	"./webp/warning_report_hover.webp": 39105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76826;